// src/services/currencyService.js
// 🆕 [MULTI-DEVISES] API devises : liste, taux, devise user
// Style aligné sur authService.js et SocialContext.js

import axios from 'axios';

// Récupère le token stocké (même pattern que SocialContext)
const getAuthHeader = () => {
  const token = localStorage.getItem('token');
  return token ? { headers: { 'x-auth-token': token } } : {};
};

/**
 * Liste des devises actives (pour le sélecteur)
 */
export async function fetchCurrencies() {
  const res = await axios.get('/api/currency/currencies');
  return res.data;
}

/**
 * Taux courants USDT → toutes devises
 */
export async function fetchRates() {
  const res = await axios.get('/api/currency/rates');
  return res.data;
}

/**
 * Devise effective de l'utilisateur + solde local calculé
 */
export async function fetchMyCurrency() {
  const res = await axios.get('/api/currency/me', getAuthHeader());
  return res.data;
}

/**
 * Change la devise préférée de l'utilisateur
 * @param {string} currency - Code devise (ex: "XOF")
 */
export async function updateMyCurrency(currency) {
  const res = await axios.patch(
    '/api/currency/me',
    { currency },
    getAuthHeader()
  );
  return res.data;
}